<template>
  <div class="miny-100vh o-hidden authentigate-login">
    <div class="login-container">
      <div class="flex-logo">
        <img
          src="../assets/logo-for-dark-bg.svg"
          alt="AuthentiGate"
        >
        <h1>Sign up</h1>
      </div>
      <v-alert
        v-if="showInvoicingText"
        max-width="500"
        type="info"
      >
        <p>
          Welcome to AuthentiGate - the worlds first Automated Asset Registry
          and Multiparty Digital Contracting platform!
        </p>

        <p>
          All new users get 14 days to evaluate the system at no charge so you
          can generate some contracts and load your registers for free.
        </p>

        <p>
          Just before the trial period expires, we will send you a email notice
          and, if you wish to continue using AuthentiGate to help organise your
          world, just follow the instructions in the email to subscribe on the
          conditions outlined on our website
          <terms-and-conditions-link class="white--text">
            here
          </terms-and-conditions-link>. Happy contracting!
        </p>
      </v-alert>
      <v-card>
        <v-card-text>
          <v-tabs v-model="tabs">
            <v-tab>Business Account</v-tab>
            <v-tab>Individual Account</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <sign-up-business-account
                @created="handleCreated"
              />
            </v-tab-item>
            <v-tab-item>
              <sign-up-single-user-account
                @created="handleCreated"
              />
            </v-tab-item>
          </v-tabs-items>
          <v-btn
            x-large
            block
            outlined
            color="primary"
            to="/login"
          >
            Back to login
          </v-btn>
        </v-card-text>
      </v-card>
      <v-row class="mb-4">
        <v-col>
          <terms-and-conditions-link class="font-weight-bold white--text" />
        </v-col>
        <v-col class="d-flex justify-end">
          <privacy-policy-link class="font-weight-bold white--text" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import SignUpSingleUserAccount from '@/components/SignUpSingleUserAccount'
import SignUpBusinessAccount from '@/components/SignUpBusinessAccount'
import PrivacyPolicyLink from '@/components/PrivacyPolicyLink'
import TermsAndConditionsLink from '@/components/TermsAndConditionsLink'

export default {
  name: 'SignUp',
  components: {
    SignUpBusinessAccount,
    SignUpSingleUserAccount,
    TermsAndConditionsLink,
    PrivacyPolicyLink
  },
  data: function () {
    return {
      tabs: null
    }
  },
  computed: {
    hasPromoCode() {
      return !!this.$route.query.promoCode
    },
    showInvoicingText() {
      return !this.hasPromoCode
    }
  },
  methods: {
    handleCreated() {
      this.$router.push('/login')
    }
  }
}
</script>
